import React from "react";
import { Avatar, CancelButton, ContainerButtons, ContentAvatars, SaveButton } from "./TPAvatar.styled";
import PropTypes from "prop-types";

const TPAvatar = ({
  handleSaveTPAvatar,
  setTPAvatarSelected,
  tpAvatarSelected,
  tpavatars,
  setOpenModalProfile,
}) => {
  return (
    <>
      <ContentAvatars>
        {Array.isArray(tpavatars) && tpavatars.map((a) => {
          return (
            <Avatar
              key={a.name}
              onClick={() => setTPAvatarSelected(a)}
              photo={`${a.url}`}
              name={`${a.name.replace("UserProfilePicture/", "")}`}
              tpAvatarSelected={`${tpAvatarSelected?.name ? tpAvatarSelected.name : tpAvatarSelected.imageName}`}
            ></Avatar>
          );
        })}
      </ContentAvatars>
      <ContainerButtons>
        <CancelButton onClick={() => setOpenModalProfile(false)}>Cancel</CancelButton>
        <SaveButton onClick={() => handleSaveTPAvatar()}>Save</SaveButton>
      </ContainerButtons>
    </>
  );
};

export default TPAvatar;

TPAvatar.propTypes = {
  handleSaveTPAvatar: PropTypes.func,
  tpAvatarSelected: PropTypes.string,
  setTPAvatarSelected: PropTypes.func,
  tpavatars: PropTypes.array,
  setOpenModalProfile: PropTypes.func,
};
